import { NavLink, Outlet } from 'react-router-dom';
import { Settings as SettingsIcon, Layers, Users, Percent, ClipboardList, FolderKanban, Tag, LayoutGrid, ListChecks, Wrench, Sparkles, Receipt, CreditCard } from 'lucide-react';
import { cn } from '@/lib/utils';

const settingsNavItems = [
  { name: 'Job Type Templates', href: '/settings/job-type-templates', icon: Layers },
  { name: 'Common Line Items', href: '/settings/common-line-items', icon: ClipboardList },
  { name: 'Project Types', href: '/settings/project-types', icon: FolderKanban },
  { name: 'Line Item Categories', href: '/settings/line-item-categories', icon: Tag },
  { name: 'Sub-Item Categories', href: '/settings/sub-item-categories', icon: LayoutGrid },
  { name: 'Expense Categories', href: '/settings/expense-categories', icon: CreditCard },
  { name: 'Category Defaults', href: '/settings/category-defaults', icon: ListChecks },
  { name: 'Workers', href: '/settings/workers', icon: Users },
  { name: 'Rates', href: '/settings/rates', icon: Percent },
  { name: 'Equipment', href: '/settings/equipment', icon: Wrench },
  { name: 'Carpet Rate Card', href: '/settings/carpet-rates', icon: Sparkles },
  { name: 'Billing', href: '/settings/billing', icon: Receipt },
];

export default function SettingsLayout() {
  return (
    <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
      <div className="flex items-center gap-3 mb-8">
        <SettingsIcon className="h-8 w-8 text-gray-700" />
        <h1 className="text-3xl font-bold text-gray-900">Settings</h1>
      </div>

      <div className="flex gap-8">
        {/* Vertical Navigation */}
        <nav className="w-56 flex-shrink-0">
          <ul className="space-y-1">
            {settingsNavItems.map((item) => (
              <li key={item.name}>
                <NavLink
                  to={item.href}
                  className={({ isActive }) =>
                    cn(
                      'flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm font-medium transition-colors',
                      isActive
                        ? 'bg-gray-900 text-white'
                        : 'text-gray-700 hover:bg-gray-100'
                    )
                  }
                >
                  <item.icon className="h-5 w-5" />
                  {item.name}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        {/* Main Content Area */}
        <main className="flex-1 min-w-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
